var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-63f47842-9245-4c71-8145-45a23484f8d5",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 398 314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M199.05,39.98444C114.05,39.98444,39.95,86.28444,.25,154.88444c39.7,68.6,113.8,114.9,198.8,114.9s158.99998-46.3,198.8-114.9c-39.80002-68.6-113.89999-114.9-198.8-114.9Zm0,205.8c-50.2,0-90.9-40.7-90.9-91,0-50.2,40.7-91,90.9-91s90.99998,40.7,90.99998,91c-.09998,50.3-40.79999,91-90.99998,91Z",
    style: {
      fill: "#255399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.45,154.88444c-17.5,0-31.60001-14.2-31.60001-31.6,0-7.8,2.89999-14.8,7.60001-20.3-6.60001-2.7-13.8-4.2-21.39999-4.2-31,0-56.09999,25.1-56.09999,56.2s25.10001,56.2,56.10001,56.2,56.19998-25.2,56.19998-56.2c0-.7-.10001-1.3-.10001-2-3.39999,1.1-7,1.9-10.7,1.9h0Z",
    style: {
      fill: "#255399"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3caea5b813c82a69707b3d354dd97b1d.svg";
export { ForwardRef as ReactComponent };